import React, { useState} from "react";
import { MenuItem } from "@mui/material/";
import SquareIcon from '@mui/icons-material/Square';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Menu from '@mui/material/Menu';
import Button from '@mui/material/Button';
import { useObjectStore } from "../zustand/objects";

import { ColorInput, DEFAULT_THEME } from '@mantine/core';

const ModelColourButton = ({ colour, id }) => {

  const swatchColours = ['#000000', '#C4A484', '#00FFFF', '#359DED', '#77D356', '#C0C0C0', '#808080', '#FFA500', '#CD303E', '#FF00FF', '#FAC710', '#FFFFFF']

  const colours = [
    { value: null, label: 'None' },
    { value: 'black', label: 'Black' },
    { value: '#C4A484', label: 'Brown' },
    { value: 'lightBlue', label: 'Light Blue' },
    { value: '#359DED', label: 'Blue' },
    { value: 'lightGreen', label: 'Light Green' },
    { value: '#77D356', label: 'Green' },
    { value: 'lightGrey', label: 'Light Grey' },
    { value: 'grey', label: 'Grey' },
    { value: 'orange', label: 'Orange' },
    { value: '#CD303E', label: 'Red' },
    { value: 'violet', label: 'Violet' },
    { value: 'white', label: 'White' },
    { value: '#FAC710', label: 'Yellow' }
  ]

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);

  };

  const [colourSet, setColourSet] = useState(colour)


  const { arrangeUndoRedo, updateShapeColour, currentObjectArtboard } = useObjectStore();

  const handleSelect = (mapped) => {
     // send current state to undoActions
     mapped && arrangeUndoRedo({
      updateType: "objectUpdate", 
      artboard: currentObjectArtboard, 
      objectID: id,
      undo:false,
      field: "colour"
      })
      // send update to zustand
    mapped && updateShapeColour({
      id: id,
      currentObjectArtboard: currentObjectArtboard,
      colour: mapped,
      undo: false
    })
    setColourSet(mapped)
  }

  return (

    // <div style={{ inline: true, marginLeft:0, paddingLeft:0, height:28, marginTop:15, paddingTop:1, fontSize: 12, width:100,  display:'flex', transition: "width 0.2s", justifyContent: 'flex-start' }}>
      <ColorInput
      closeOnColorSwatchClick
      placeholder="Colour"
      defaultValue={colourSet}
      onChange={(e) => handleSelect(e)}
      label="Colour"
      size="sm"
      // radius={32}
      disallowInput
      withPicker={true}
      withEyeDropper={true}
      swatches={[...swatchColours]}
      swatchesPerRow={6}
      
    />
    // </div>


  );
};

export default ModelColourButton;











